import { IEmpresas } from "../interfaces/IEmpresas";
import api from "./Api";

class EmpresaNovaService {
    async buscar(): Promise<IEmpresas[]> {
        const { data: result } = await api.get<IEmpresas[]>('Empresa');

        return result;
    }

    async buscarEmpresasIntegracao(offset: number = 0, perPage: number = 10, q: string = ''): Promise<IEmpresas[]> {
        const { data: result } = await api.get<IEmpresas[]>(`Empresa/integracao?offset=${offset}&perPage=${perPage}&q=${q}`);
        return result;
    }

    async buscarPorId(id: number): Promise<IEmpresas> {
        const { data: result } = await api.get<IEmpresas>(`v2/Empresa/${id}`);

        return result;
    }

    async buscarTodas(): Promise<IEmpresas[]> {
        const { data: result } = await api.get<IEmpresas[]>('Empresa/all', {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
        });

        return result;
    }

    async buscarPorIdNova(id: number): Promise<IEmpresas> {
        const { data: result } = await api.get<IEmpresas>(`Empresa/id/${id}`, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
        });

        return result;
    }

    async buscarPorClientePaginado(clienteID: number, offset: number, q?: string): Promise<{
        data: IEmpresas[];
        totalPaginas: number;
    }> {
        const { data: result } = await api.get<{
            data: IEmpresas[];
            totalPaginas: number;
        }>(`Empresa/cliente/${clienteID}?q=${q}&offset=${offset}`, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
        });

        return result;
    }

    async atualizar(empresa: IEmpresas): Promise<IEmpresas> {
        const { data: result } = await api.put<IEmpresas>(`Empresa/${empresa.id}`, empresa, {
            baseURL: process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/'
        });

        return result;
    }
}


export default new EmpresaNovaService();